import { render, staticRenderFns } from "./TokensDemandContainer.vue?vue&type=template&id=648b39a0&"
import script from "./TokensDemandContainer.vue?vue&type=script&lang=js&"
export * from "./TokensDemandContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports